//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

// import moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:8889/api";
    }

    /**
     * List Available Accounts
     * @param status (optional) 
     * @param name (optional) 
     */
    list(page: number, per_page: number, status: boolean | undefined, name: string | undefined): Observable<Anonymous> {
        let url_ = this.baseUrl + "/admin/account/list?";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (per_page === undefined || per_page === null)
            throw new Error("The parameter 'per_page' must be defined and cannot be null.");
        else
            url_ += "per_page=" + encodeURIComponent("" + per_page) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<Anonymous> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Anonymous.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = Anonymous2.fromJS(resultData401);
                return throwException("Unauthenticated", status, _responseText, _headers, result401);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result422: any = null;
                let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result422 = Anonymous3.fromJS(resultData422);
                return throwException("Validation error", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    show(): Observable<Anonymous4> {
        let url_ = this.baseUrl + "/admin/account/show";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processShow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous4>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous4>;
        }));
    }

    protected processShow(response: HttpResponseBase): Observable<Anonymous4> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Anonymous4.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = Anonymous2.fromJS(resultData401);
                return throwException("Unauthenticated", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:8889/api";
    }

    register(body: any | undefined): Observable<Anonymous5> {
        let url_ = this.baseUrl + "/auth/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous5>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous5>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<Anonymous5> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Anonymous5.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    login(body: UserLoginRequest | undefined): Observable<Anonymous7> {
        let url_ = this.baseUrl + "/auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous7>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous7>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<Anonymous7> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result500: any = null;
                let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result500 = Anonymous6.fromJS(resultData500);
                return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Anonymous7.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result422: any = null;
                let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result422 = Anonymous3.fromJS(resultData422);
                return throwException("Validation error", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLoggedInUserDetails(): Observable<Anonymous8> {
        let url_ = this.baseUrl + "/auth/getLoggedInUserDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLoggedInUserDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoggedInUserDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous8>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous8>;
        }));
    }

    protected processGetLoggedInUserDetails(response: HttpResponseBase): Observable<Anonymous8> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Anonymous8.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = Anonymous2.fromJS(resultData401);
                return throwException("Unauthenticated", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TestingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:8889/api";
    }

    sendException(): Observable<void> {
        let url_ = this.baseUrl + "/testing/sendException";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendException(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendException(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendException(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionEnabled(): Observable<void> {
        let url_ = this.baseUrl + "/testing/transactionEnabled";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processTransactionEnabled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionEnabled(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTransactionEnabled(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    transactionDisabled(): Observable<void> {
        let url_ = this.baseUrl + "/testing/transactionDisabled";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processTransactionDisabled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionDisabled(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTransactionDisabled(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    generateTestTokenWithCustomClaims(body: any | undefined): Observable<Anonymous9> {
        let url_ = this.baseUrl + "/testing/generateTestTokenWithCustomClaims";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGenerateTestTokenWithCustomClaims(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateTestTokenWithCustomClaims(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous9>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous9>;
        }));
    }

    protected processGenerateTestTokenWithCustomClaims(response: HttpResponseBase): Observable<Anonymous9> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Anonymous9.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    viewPatientVitalStats(): Observable<Anonymous10> {
        let url_ = this.baseUrl + "/testing/viewPatientVitalStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processViewPatientVitalStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processViewPatientVitalStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous10>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous10>;
        }));
    }

    protected processViewPatientVitalStats(response: HttpResponseBase): Observable<Anonymous10> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Anonymous10.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = Anonymous2.fromJS(resultData401);
                return throwException("Unauthenticated", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    addPatientVitalStats(body: any | undefined): Observable<Anonymous11> {
        let url_ = this.baseUrl + "/testing/addPatientVitalStats";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAddPatientVitalStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPatientVitalStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous11>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous11>;
        }));
    }

    protected processAddPatientVitalStats(response: HttpResponseBase): Observable<Anonymous11> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Anonymous11.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = Anonymous2.fromJS(resultData401);
                return throwException("Unauthenticated", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updatePatientVitalStats(body: any | undefined): Observable<Anonymous12> {
        let url_ = this.baseUrl + "/testing/updatePatientVitalStats";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdatePatientVitalStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePatientVitalStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous12>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous12>;
        }));
    }

    protected processUpdatePatientVitalStats(response: HttpResponseBase): Observable<Anonymous12> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Anonymous12.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = Anonymous2.fromJS(resultData401);
                return throwException("Unauthenticated", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePatientVitalStats(): Observable<Anonymous13> {
        let url_ = this.baseUrl + "/testing/deletePatientVitalStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeletePatientVitalStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePatientVitalStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous13>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous13>;
        }));
    }

    protected processDeletePatientVitalStats(response: HttpResponseBase): Observable<Anonymous13> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Anonymous13.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = Anonymous2.fromJS(resultData401);
                return throwException("Unauthenticated", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    viewPatientDetails(): Observable<Anonymous14> {
        let url_ = this.baseUrl + "/testing/viewPatientDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processViewPatientDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processViewPatientDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Anonymous14>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Anonymous14>;
        }));
    }

    protected processViewPatientDetails(response: HttpResponseBase): Observable<Anonymous14> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Anonymous14.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = Anonymous2.fromJS(resultData401);
                return throwException("Unauthenticated", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AccountResource implements IAccountResource {
    id: number;
    name: string | undefined;
    address: string;
    city: string;
    state: string;
    zip_code: string;
    phone_number: string;
    type: string;
    affiliate_count: string;
    user_count: string;
    admin_count: string;
    spiro_count: string;
    isactive: string;

    [key: string]: any;

    constructor(data?: IAccountResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip_code = _data["zip_code"];
            this.phone_number = _data["phone_number"];
            this.type = _data["type"];
            this.affiliate_count = _data["affiliate_count"];
            this.user_count = _data["user_count"];
            this.admin_count = _data["admin_count"];
            this.spiro_count = _data["spiro_count"];
            this.isactive = _data["isactive"];
        }
    }

    static fromJS(data: any): AccountResource {
        data = typeof data === 'object' ? data : {};
        let result = new AccountResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip_code"] = this.zip_code;
        data["phone_number"] = this.phone_number;
        data["type"] = this.type;
        data["affiliate_count"] = this.affiliate_count;
        data["user_count"] = this.user_count;
        data["admin_count"] = this.admin_count;
        data["spiro_count"] = this.spiro_count;
        data["isactive"] = this.isactive;
        return data;
    }

    clone(): AccountResource {
        const json = this.toJSON();
        let result = new AccountResource();
        result.init(json);
        return result;
    }
}

export interface IAccountResource {
    id: number;
    name: string | undefined;
    address: string;
    city: string;
    state: string;
    zip_code: string;
    phone_number: string;
    type: string;
    affiliate_count: string;
    user_count: string;
    admin_count: string;
    spiro_count: string;
    isactive: string;

    [key: string]: any;
}

export class UserLoginRequest implements IUserLoginRequest {
    email: string;
    password: string;

    [key: string]: any;

    constructor(data?: IUserLoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): UserLoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }

    clone(): UserLoginRequest {
        const json = this.toJSON();
        let result = new UserLoginRequest();
        result.init(json);
        return result;
    }
}

export interface IUserLoginRequest {
    email: string;
    password: string;

    [key: string]: any;
}

export class Anonymous implements IAnonymous {
    data: AccountResource[];
    status: number;
    statusCode: string;
    returnCode: string;
    isAppResponse: boolean;
    message: string;

    [key: string]: any;

    constructor(data?: IAnonymous) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["Data"])) {
                this.data = [] as any;
                for (let item of _data["Data"])
                    this.data.push(AccountResource.fromJS(item));
            }
            this.status = _data["Status"];
            this.statusCode = _data["StatusCode"];
            this.returnCode = _data["ReturnCode"];
            this.isAppResponse = _data["IsAppResponse"];
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): Anonymous {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.data)) {
            data["Data"] = [];
            for (let item of this.data)
                data["Data"].push(item.toJSON());
        }
        data["Status"] = this.status;
        data["StatusCode"] = this.statusCode;
        data["ReturnCode"] = this.returnCode;
        data["IsAppResponse"] = this.isAppResponse;
        data["Message"] = this.message;
        return data;
    }

    clone(): Anonymous {
        const json = this.toJSON();
        let result = new Anonymous();
        result.init(json);
        return result;
    }
}

export interface IAnonymous {
    data: AccountResource[];
    status: number;
    statusCode: string;
    returnCode: string;
    isAppResponse: boolean;
    message: string;

    [key: string]: any;
}

export class Anonymous2 implements IAnonymous2 {
    /** Error overview. */
    message: string;

    [key: string]: any;

    constructor(data?: IAnonymous2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): Anonymous2 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        return data;
    }

    clone(): Anonymous2 {
        const json = this.toJSON();
        let result = new Anonymous2();
        result.init(json);
        return result;
    }
}

export interface IAnonymous2 {
    /** Error overview. */
    message: string;

    [key: string]: any;
}

export class Anonymous3 implements IAnonymous3 {
    /** Errors overview. */
    message: string;
    /** A detailed description of each field that failed validation. */
    errors: { [key: string]: string[]; };

    [key: string]: any;

    constructor(data?: IAnonymous3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.errors = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)[key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): Anonymous3 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        return data;
    }

    clone(): Anonymous3 {
        const json = this.toJSON();
        let result = new Anonymous3();
        result.init(json);
        return result;
    }
}

export interface IAnonymous3 {
    /** Errors overview. */
    message: string;
    /** A detailed description of each field that failed validation. */
    errors: { [key: string]: string[]; };

    [key: string]: any;
}

export class Anonymous4 implements IAnonymous4 {
    data: Data;
    status: string;
    statusCode: number;
    returnCode: string;
    isAppResponse: boolean;
    message: string;

    [key: string]: any;

    constructor(data?: IAnonymous4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = new Data();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["Data"] ? Data.fromJS(_data["Data"]) : new Data();
            this.status = _data["Status"];
            this.statusCode = _data["StatusCode"];
            this.returnCode = _data["ReturnCode"];
            this.isAppResponse = _data["IsAppResponse"];
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): Anonymous4 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["Data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["Status"] = this.status;
        data["StatusCode"] = this.statusCode;
        data["ReturnCode"] = this.returnCode;
        data["IsAppResponse"] = this.isAppResponse;
        data["Message"] = this.message;
        return data;
    }

    clone(): Anonymous4 {
        const json = this.toJSON();
        let result = new Anonymous4();
        result.init(json);
        return result;
    }
}

export interface IAnonymous4 {
    data: Data;
    status: string;
    statusCode: number;
    returnCode: string;
    isAppResponse: boolean;
    message: string;

    [key: string]: any;
}

export class Anonymous5 implements IAnonymous5 {
    data: data;
    status: string;
    statusCode: number;
    returnCode: string;
    isAppResponse: boolean;
    message: string;

    [key: string]: any;

    constructor(data?: IAnonymous5) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        // if (!data) {
        //     this.data = new data();
        // }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["Data"] ? data.fromJS(_data["Data"]) : new data();
            this.status = _data["Status"];
            this.statusCode = _data["StatusCode"];
            this.returnCode = _data["ReturnCode"];
            this.isAppResponse = _data["IsAppResponse"];
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): Anonymous5 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous5();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["Data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["Status"] = this.status;
        data["StatusCode"] = this.statusCode;
        data["ReturnCode"] = this.returnCode;
        data["IsAppResponse"] = this.isAppResponse;
        data["Message"] = this.message;
        return data;
    }

    clone(): Anonymous5 {
        const json = this.toJSON();
        let result = new Anonymous5();
        result.init(json);
        return result;
    }
}

export interface IAnonymous5 {
    data: data;
    status: string;
    statusCode: number;
    returnCode: string;
    isAppResponse: boolean;
    message: string;

    [key: string]: any;
}

export class Anonymous6 implements IAnonymous6 {
    data: number;
    status: string;
    statusCode: number;
    returnCode: string;
    isAppResponse: boolean;
    message: string;

    [key: string]: any;

    constructor(data?: IAnonymous6) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["Data"];
            this.status = _data["Status"];
            this.statusCode = _data["StatusCode"];
            this.returnCode = _data["ReturnCode"];
            this.isAppResponse = _data["IsAppResponse"];
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): Anonymous6 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous6();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["Data"] = this.data;
        data["Status"] = this.status;
        data["StatusCode"] = this.statusCode;
        data["ReturnCode"] = this.returnCode;
        data["IsAppResponse"] = this.isAppResponse;
        data["Message"] = this.message;
        return data;
    }

    clone(): Anonymous6 {
        const json = this.toJSON();
        let result = new Anonymous6();
        result.init(json);
        return result;
    }
}

export interface IAnonymous6 {
    data: number;
    status: string;
    statusCode: number;
    returnCode: string;
    isAppResponse: boolean;
    message: string;

    [key: string]: any;
}

export class Anonymous7 implements IAnonymous7 {
    data: data2;
    status: string;
    statusCode: number;
    returnCode: string;
    isAppResponse: boolean;
    message: string;

    [key: string]: any;

    constructor(data?: IAnonymous7) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = new data2();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["Data"] ? data2.fromJS(_data["Data"]) : new data2();
            this.status = _data["Status"];
            this.statusCode = _data["StatusCode"];
            this.returnCode = _data["ReturnCode"];
            this.isAppResponse = _data["IsAppResponse"];
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): Anonymous7 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous7();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["Data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["Status"] = this.status;
        data["StatusCode"] = this.statusCode;
        data["ReturnCode"] = this.returnCode;
        data["IsAppResponse"] = this.isAppResponse;
        data["Message"] = this.message;
        return data;
    }

    clone(): Anonymous7 {
        const json = this.toJSON();
        let result = new Anonymous7();
        result.init(json);
        return result;
    }
}

export interface IAnonymous7 {
    data: data2;
    status: string;
    statusCode: number;
    returnCode: string;
    isAppResponse: boolean;
    message: string;

    [key: string]: any;
}

export class Anonymous8 implements IAnonymous8 {
    data: data3;
    status: string;
    statusCode: number;
    returnCode: string;
    isAppResponse: boolean;
    message: string;

    [key: string]: any;

    constructor(data?: IAnonymous8) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = new data3();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["Data"] ? data3.fromJS(_data["Data"]) : new data3();
            this.status = _data["Status"];
            this.statusCode = _data["StatusCode"];
            this.returnCode = _data["ReturnCode"];
            this.isAppResponse = _data["IsAppResponse"];
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): Anonymous8 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous8();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["Data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["Status"] = this.status;
        data["StatusCode"] = this.statusCode;
        data["ReturnCode"] = this.returnCode;
        data["IsAppResponse"] = this.isAppResponse;
        data["Message"] = this.message;
        return data;
    }

    clone(): Anonymous8 {
        const json = this.toJSON();
        let result = new Anonymous8();
        result.init(json);
        return result;
    }
}

export interface IAnonymous8 {
    data: data3;
    status: string;
    statusCode: number;
    returnCode: string;
    isAppResponse: boolean;
    message: string;

    [key: string]: any;
}

export class Anonymous9 implements IAnonymous9 {
    data: data4;
    status: string;
    statusCode: number;
    returnCode: string;
    isAppResponse: boolean;
    message: string;

    [key: string]: any;

    constructor(data?: IAnonymous9) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = new data4();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["Data"] ? data4.fromJS(_data["Data"]) : new data4();
            this.status = _data["Status"];
            this.statusCode = _data["StatusCode"];
            this.returnCode = _data["ReturnCode"];
            this.isAppResponse = _data["IsAppResponse"];
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): Anonymous9 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous9();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["Data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["Status"] = this.status;
        data["StatusCode"] = this.statusCode;
        data["ReturnCode"] = this.returnCode;
        data["IsAppResponse"] = this.isAppResponse;
        data["Message"] = this.message;
        return data;
    }

    clone(): Anonymous9 {
        const json = this.toJSON();
        let result = new Anonymous9();
        result.init(json);
        return result;
    }
}

export interface IAnonymous9 {
    data: data4;
    status: string;
    statusCode: number;
    returnCode: string;
    isAppResponse: boolean;
    message: string;

    [key: string]: any;
}

export class Anonymous10 implements IAnonymous10 {
    data: data5;
    status: string;
    statusCode: number;
    returnCode: string;
    isAppResponse: boolean;
    message: string;

    [key: string]: any;

    constructor(data?: IAnonymous10) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = new data5();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["Data"] ? data5.fromJS(_data["Data"]) : new data5();
            this.status = _data["Status"];
            this.statusCode = _data["StatusCode"];
            this.returnCode = _data["ReturnCode"];
            this.isAppResponse = _data["IsAppResponse"];
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): Anonymous10 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous10();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["Data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["Status"] = this.status;
        data["StatusCode"] = this.statusCode;
        data["ReturnCode"] = this.returnCode;
        data["IsAppResponse"] = this.isAppResponse;
        data["Message"] = this.message;
        return data;
    }

    clone(): Anonymous10 {
        const json = this.toJSON();
        let result = new Anonymous10();
        result.init(json);
        return result;
    }
}

export interface IAnonymous10 {
    data: data5;
    status: string;
    statusCode: number;
    returnCode: string;
    isAppResponse: boolean;
    message: string;

    [key: string]: any;
}

export class Anonymous11 implements IAnonymous11 {
    data: data6;
    status: string;
    statusCode: number;
    returnCode: string;
    isAppResponse: boolean;
    message: string;

    [key: string]: any;

    constructor(data?: IAnonymous11) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = new data6();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["Data"] ? data6.fromJS(_data["Data"]) : new data6();
            this.status = _data["Status"];
            this.statusCode = _data["StatusCode"];
            this.returnCode = _data["ReturnCode"];
            this.isAppResponse = _data["IsAppResponse"];
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): Anonymous11 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous11();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["Data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["Status"] = this.status;
        data["StatusCode"] = this.statusCode;
        data["ReturnCode"] = this.returnCode;
        data["IsAppResponse"] = this.isAppResponse;
        data["Message"] = this.message;
        return data;
    }

    clone(): Anonymous11 {
        const json = this.toJSON();
        let result = new Anonymous11();
        result.init(json);
        return result;
    }
}

export interface IAnonymous11 {
    data: data6;
    status: string;
    statusCode: number;
    returnCode: string;
    isAppResponse: boolean;
    message: string;

    [key: string]: any;
}

export class Anonymous12 implements IAnonymous12 {
    data: data7;
    status: string;
    statusCode: number;
    returnCode: string;
    isAppResponse: boolean;
    message: string;

    [key: string]: any;

    constructor(data?: IAnonymous12) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = new data7();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["Data"] ? data7.fromJS(_data["Data"]) : new data7();
            this.status = _data["Status"];
            this.statusCode = _data["StatusCode"];
            this.returnCode = _data["ReturnCode"];
            this.isAppResponse = _data["IsAppResponse"];
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): Anonymous12 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous12();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["Data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["Status"] = this.status;
        data["StatusCode"] = this.statusCode;
        data["ReturnCode"] = this.returnCode;
        data["IsAppResponse"] = this.isAppResponse;
        data["Message"] = this.message;
        return data;
    }

    clone(): Anonymous12 {
        const json = this.toJSON();
        let result = new Anonymous12();
        result.init(json);
        return result;
    }
}

export interface IAnonymous12 {
    data: data7;
    status: string;
    statusCode: number;
    returnCode: string;
    isAppResponse: boolean;
    message: string;

    [key: string]: any;
}

export class Anonymous13 implements IAnonymous13 {
    data: data8;
    status: string;
    statusCode: number;
    returnCode: string;
    isAppResponse: boolean;
    message: string;

    [key: string]: any;

    constructor(data?: IAnonymous13) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = new data8();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["Data"] ? data8.fromJS(_data["Data"]) : new data8();
            this.status = _data["Status"];
            this.statusCode = _data["StatusCode"];
            this.returnCode = _data["ReturnCode"];
            this.isAppResponse = _data["IsAppResponse"];
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): Anonymous13 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous13();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["Data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["Status"] = this.status;
        data["StatusCode"] = this.statusCode;
        data["ReturnCode"] = this.returnCode;
        data["IsAppResponse"] = this.isAppResponse;
        data["Message"] = this.message;
        return data;
    }

    clone(): Anonymous13 {
        const json = this.toJSON();
        let result = new Anonymous13();
        result.init(json);
        return result;
    }
}

export interface IAnonymous13 {
    data: data8;
    status: string;
    statusCode: number;
    returnCode: string;
    isAppResponse: boolean;
    message: string;

    [key: string]: any;
}

export class Anonymous14 implements IAnonymous14 {
    data: data9;
    status: string;
    statusCode: number;
    returnCode: string;
    isAppResponse: boolean;
    message: string;

    [key: string]: any;

    constructor(data?: IAnonymous14) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = new data9();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.data = _data["Data"] ? data9.fromJS(_data["Data"]) : new data9();
            this.status = _data["Status"];
            this.statusCode = _data["StatusCode"];
            this.returnCode = _data["ReturnCode"];
            this.isAppResponse = _data["IsAppResponse"];
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): Anonymous14 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous14();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["Data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["Status"] = this.status;
        data["StatusCode"] = this.statusCode;
        data["ReturnCode"] = this.returnCode;
        data["IsAppResponse"] = this.isAppResponse;
        data["Message"] = this.message;
        return data;
    }

    clone(): Anonymous14 {
        const json = this.toJSON();
        let result = new Anonymous14();
        result.init(json);
        return result;
    }
}

export interface IAnonymous14 {
    data: data9;
    status: string;
    statusCode: number;
    returnCode: string;
    isAppResponse: boolean;
    message: string;

    [key: string]: any;
}

export class Data implements IData {
    user: string;
    token: string;

    [key: string]: any;

    constructor(data?: IData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.user = _data["user"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): Data {
        data = typeof data === 'object' ? data : {};
        let result = new Data();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["user"] = this.user;
        data["token"] = this.token;
        return data;
    }

    clone(): Data {
        const json = this.toJSON();
        let result = new Data();
        result.init(json);
        return result;
    }
}

export interface IData {
    user: string;
    token: string;

    [key: string]: any;
}

export class data implements Idata {
    user: string;
    token: string;

    [key: string]: any;

    constructor(data?: Idata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.user = _data["user"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): data {
        data = typeof data === 'object' ? data : {};
        let result = new data();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["user"] = this.user;
        data["token"] = this.token;
        return data;
    }

    clone(): data {
        const json = this.toJSON();
        let result = new data();
        result.init(json);
        return result;
    }
}

export interface Idata {
    user: string;
    token: string;

    [key: string]: any;
}

export class data2 implements Idata2 {
    user: string;
    token: string;

    [key: string]: any;

    constructor(data?: Idata2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.user = _data["user"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): data2 {
        data = typeof data === 'object' ? data : {};
        let result = new data2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["user"] = this.user;
        data["token"] = this.token;
        return data;
    }

    clone(): data2 {
        const json = this.toJSON();
        let result = new data2();
        result.init(json);
        return result;
    }
}

export interface Idata2 {
    user: string;
    token: string;

    [key: string]: any;
}

export class data3 implements Idata3 {
    user: string;
    token: string;

    [key: string]: any;

    constructor(data?: Idata3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.user = _data["user"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): data3 {
        data = typeof data === 'object' ? data : {};
        let result = new data3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["user"] = this.user;
        data["token"] = this.token;
        return data;
    }

    clone(): data3 {
        const json = this.toJSON();
        let result = new data3();
        result.init(json);
        return result;
    }
}

export interface Idata3 {
    user: string;
    token: string;

    [key: string]: any;
}

export class data4 implements Idata4 {
    user: string;
    token: string;

    [key: string]: any;

    constructor(data?: Idata4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.user = _data["user"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): data4 {
        data = typeof data === 'object' ? data : {};
        let result = new data4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["user"] = this.user;
        data["token"] = this.token;
        return data;
    }

    clone(): data4 {
        const json = this.toJSON();
        let result = new data4();
        result.init(json);
        return result;
    }
}

export interface Idata4 {
    user: string;
    token: string;

    [key: string]: any;
}

export class data5 implements Idata5 {
    user: string;
    token: string;

    [key: string]: any;

    constructor(data?: Idata5) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.user = _data["user"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): data5 {
        data = typeof data === 'object' ? data : {};
        let result = new data5();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["user"] = this.user;
        data["token"] = this.token;
        return data;
    }

    clone(): data5 {
        const json = this.toJSON();
        let result = new data5();
        result.init(json);
        return result;
    }
}

export interface Idata5 {
    user: string;
    token: string;

    [key: string]: any;
}

export class data6 implements Idata6 {
    user: string;
    token: string;

    [key: string]: any;

    constructor(data?: Idata6) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.user = _data["user"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): data6 {
        data = typeof data === 'object' ? data : {};
        let result = new data6();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["user"] = this.user;
        data["token"] = this.token;
        return data;
    }

    clone(): data6 {
        const json = this.toJSON();
        let result = new data6();
        result.init(json);
        return result;
    }
}

export interface Idata6 {
    user: string;
    token: string;

    [key: string]: any;
}

export class data7 implements Idata7 {
    user: string;
    token: string;

    [key: string]: any;

    constructor(data?: Idata7) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.user = _data["user"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): data7 {
        data = typeof data === 'object' ? data : {};
        let result = new data7();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["user"] = this.user;
        data["token"] = this.token;
        return data;
    }

    clone(): data7 {
        const json = this.toJSON();
        let result = new data7();
        result.init(json);
        return result;
    }
}

export interface Idata7 {
    user: string;
    token: string;

    [key: string]: any;
}

export class data8 implements Idata8 {
    user: string;
    token: string;

    [key: string]: any;

    constructor(data?: Idata8) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.user = _data["user"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): data8 {
        data = typeof data === 'object' ? data : {};
        let result = new data8();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["user"] = this.user;
        data["token"] = this.token;
        return data;
    }

    clone(): data8 {
        const json = this.toJSON();
        let result = new data8();
        result.init(json);
        return result;
    }
}

export interface Idata8 {
    user: string;
    token: string;

    [key: string]: any;
}

export class data9 implements Idata9 {
    user: string;
    token: string;

    [key: string]: any;

    constructor(data?: Idata9) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.user = _data["user"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): data9 {
        data = typeof data === 'object' ? data : {};
        let result = new data9();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["user"] = this.user;
        data["token"] = this.token;
        return data;
    }

    clone(): data9 {
        const json = this.toJSON();
        let result = new data9();
        result.init(json);
        return result;
    }
}

export interface Idata9 {
    user: string;
    token: string;

    [key: string]: any;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}